import { vars } from '@etg/wings';
import { css, cx, etiColors } from '@eti/styles';
import SeatMapDeck from '../../components/SeatMapDeck';
import DeckSelection from './DeckSelection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const mainContentStyles = css`
  background-color: ${etiColors.white};
  border-top: 1px solid ${vars.colors.divider};
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
`;
const seatMapDeckWrapperStyles = css`
  background: ${etiColors.grayScale[3]};
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;
const SeatMapMainContent = _ref => {
  let {
    active,
    deckOptions = [],
    direction,
    isFromSummary,
    onChangeSeat,
    onDeckChange,
    segments,
    selectedDeck,
    selectedSeats,
    travelers
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cx(mainContentStyles, 'seatMap__main'),
    "data-testid": "seatmap-mainContent",
    children: /*#__PURE__*/_jsxs("div", {
      className: seatMapDeckWrapperStyles,
      children: [deckOptions.length > 1 && /*#__PURE__*/_jsx(DeckSelection, {
        onValueChange: onDeckChange,
        options: deckOptions,
        selected: selectedDeck
      }), /*#__PURE__*/_jsx(SeatMapDeck, {
        active: active,
        direction: direction,
        isFromSummary: isFromSummary,
        onChange: onChangeSeat,
        segments: segments,
        selectedDeck: selectedDeck,
        selectedSeats: selectedSeats,
        travelers: travelers
      })]
    })
  });
};
export default SeatMapMainContent;
//# sourceMappingURL=SeatMapMainContent.js.map